<script setup>
import UserList from '@/components/admin/UserList.vue';
</script>
<template>
  <div class="-mx-10 flex h-screen bg-gray-50">
    <aside class="w-80 bg-white border-r border-gray-200 flex flex-col shadow-sm">
      <div class="p-4 border-b border-gray-100 bg-gray-50/50">
        <h2 class="text-xl font-bold text-gray-800 flex items-center gap-2">
          <span class="p-1.5 bg-orange-300 rounded-sm text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-3 h-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </span>
          管理者用ページ
        </h2>
        <p class="text-md text-gray-500 mt-1">ユーザーを選択して編集します</p>
      </div>

      <div class="flex-1 overflow-y-auto p-2">
        <UserList />
      </div>
    </aside>

    <main class="flex-1 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto p-8">
        <div
          v-if="$route.name === 'Admin'"
          class="h-[60vh] flex flex-col items-center justify-center text-center border-2 border-dashed border-gray-200 rounded-2xl bg-gray-50/30"
        >
          <div class="bg-gray-100 p-4 rounded-full mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-12 h-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
          </div>
          <h3 class="text-lg font-medium text-gray-900">ユーザーを選択してください</h3>
          <p class="text-gray-500 max-w-xs mt-2">
            左側のリストから、情報を編集したいユーザーをクリックしてください。
          </p>
        </div>
        <!--
                現在のURLに一致するコンポーネントをComponentに格納し、
                :isで画面に描画
                :is-adminでPropsを渡す
                -->
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" :is-admin="true" />
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<style scoped>
/* 切り替わり時のふわっとしたアニメーション */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
